import React, { useEffect } from 'react';
import { useLocation } from '@reach/router';
import { Box } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import { Link as GatsbyLink, navigate } from 'gatsby';
import { ArrowButton } from '@hover/shared-components';
import { Layout } from '../v2/components/common';
import { Title } from '../v2/components/not-found';

const Page404 = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.includes('job-posts')) void navigate('/careers');
    else if (pathname.includes('blog')) void navigate('/blog');
  }, [pathname]);

  return (
    <Layout noIndex>
      <Box
        py={{ base: 800, tablet: '80px' }}
        px={{ base: 500, tablet: '56px' }}
        flexDir="column"
        alignItems="center"
      >
        <StaticImage
          placeholder="blurred"
          width={620}
          objectFit="contain"
          loading="eager"
          alt="not found"
          src="../v2/assets/images/not_found.png"
        />
        <Box
          mt={{ base: 600, tablet: 700 }}
          mb={200}
          flexDir={{ base: 'column', tablet: 'row' }}
        >
          <Title content="Oops!" mr={{ base: 0, tablet: 200 }} />
          <Title content="We couldn’t find this page." />
        </Box>
        <ArrowButton
          as={GatsbyLink}
          to="/"
          variant="minimal"
          w={{ base: '100%', tablet: 'auto' }}
          sx={{
            // TODO(buttons): remove when we remove padding in Blueprint
            div: { pl: 0, pr: 50 },
          }}
        >
          Let’s head home
        </ArrowButton>
      </Box>
    </Layout>
  );
};

export default Page404;
